<template>

<b-card class="card-transaction" no-body  >
  <b-card-body>
    <h1 class="text-center" v-if="!estabelecimento.name">Selecione um estabelecimento!</h1>

  <b-tabs v-if="estabelecimento.name" content-class="mt-2" justified>
  
    
    <b-tab title="Ordens" :active="statusTab" >
     <OrdensEstabelecimento></OrdensEstabelecimento>
    </b-tab>

    <b-tab title="Extrato" >
      <ListaFinanceiraVue ></ListaFinanceiraVue>
     <ListaMovimentoVue></ListaMovimentoVue>
    </b-tab>

    <b-tab title="Informações" >
    <FormEstabelecimento></FormEstabelecimento>
    </b-tab>
     <b-tab title="Custos de emissão">
      <TaxasEstabelecimento></TaxasEstabelecimento>
    </b-tab>
    <!-- <b-tab title="Configurações">
      <ConfigEstabelecimento></ConfigEstabelecimento>
    </b-tab> -->

    <b-tab title="Integração">
      <IntegracaoEstabelecimento></IntegracaoEstabelecimento>
    </b-tab>
   
  </b-tabs>
  </b-card-body>
</b-card>
</template>

<script>
import { BTabs, BTab, BCardText, BCard, BCardHeader, BCardBody } from 'bootstrap-vue'
import FormEstabelecimento from './FormEstabelecimento.vue'
import OrdensEstabelecimento from './OrdensEstabelecimento.vue'
import ConfigEstabelecimento from './ConfigEstabelecimento.vue'
import TaxasEstabelecimento from './TaxasEstabelecimento.vue'
import IntegracaoEstabelecimento from './IntegracaoEstabelecimento.vue'
import ListaMovimentoVue from './extrato/ListaMovimento.vue'
import ListaFinanceiraVue from './extrato/ListaFinanceira..vue'

export default {
  components: {
    BCardText,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    FormEstabelecimento,
    OrdensEstabelecimento,
    ConfigEstabelecimento,
    TaxasEstabelecimento,
    IntegracaoEstabelecimento,
    ListaMovimentoVue,
    ListaFinanceiraVue
},


  data() {
    return {
        statusTab:true,
        
      }
  },

  created() {
    
  },
  
  watch:{
    statusTab(data){

      return true
    }
  },

  computed:{
     estabelecimento() {
    
        return this.$store.state.estabelecimentos.estabelecimento.allEstablishment;
    },
   
  }
}
</script>